<div matRipple>
    @if (isLoading()) {
    <shared-loading [interval]="0.75" [viewBox]="'100 0 900 300'"></shared-loading>
    } @else {
    <shared-loading [viewBox]="'100 0 900 300'" [gradientRatio]="0.00001"></shared-loading>
    }
</div>

